import React from 'react';
import { FaInstagram, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

const Contact = () => {
    usePageTitle("Contact | Dinara Fariz");

    return (
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-12">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
                <div className="w-full md:w-1/2 flex justify-center">
                    <img
                        src="/DinaraContact.JPG"
                        alt="Dinara Fariz"
                        className="w-full max-w-[320px] h-auto object-cover border border-gray-200 shadow-sm"
                    />
                </div>

                <div className="w-full md:w-1/2 text-center md:text-left text-gray-800">
                    <h1 className="text-2xl md:text-3xl font-light uppercase tracking-[0.2em] mb-6">
                        Contact
                    </h1>

                    <p className="text-base leading-relaxed mb-6">
                        If you are interested in an available artwork, a commissioned painting,
                        or a creative collaboration, I would be happy to <Link to="/login">hear</Link> from you.
                    </p>

                    <div className="flex justify-center md:justify-start gap-6 mb-6">
                        <a
                            href="https://www.instagram.com/dinarafar/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center gap-2 text-gray-600 hover:text-black transition"
                        >
                            <FaInstagram className="text-2xl" />
                            <span className="text-xs uppercase tracking-[0.2em]">Instagram</span>
                        </a>

                        <a
                            href="https://wa.me/77014311654"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center gap-2 text-gray-600 hover:text-black transition"
                        >
                            <FaWhatsapp className="text-2xl" />
                            <span className="text-xs uppercase tracking-[0.2em]">WhatsApp</span>
                        </a>

                        <a
                            href="mailto:dinarafar@gmail.com"
                            className="flex flex-col items-center gap-2 text-gray-600 hover:text-black transition"
                        >
                            <FaEnvelope className="text-2xl" />
                            <span className="text-xs uppercase tracking-[0.2em]">Email</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;